export default {
      id: "ic-malentendant-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-malentendant-usage",
      toString: function () {
        return this.url;
      }
    }